import { ref } from "vue";

const displayedAdIds = ref( new Set<string>() );

export function useAdTracker () {
    // Attempts to reserve an ad ID. Returns true if successful, false if already reserved.
    const reserveAdId = ( id: string ): boolean => {
        if ( displayedAdIds.value.has( id ) ) {
            return false; // Already reserved
        }
        const newSet = new Set( displayedAdIds.value );
        newSet.add( id );
        displayedAdIds.value = newSet;
        return true;
    };

    // Releases an ad ID, making it available again.
    const releaseAdId = ( id: string | null ): void => {
        if ( id && displayedAdIds.value.has( id ) ) {
            const newSet = new Set( displayedAdIds.value );
            newSet.delete( id );
            displayedAdIds.value = newSet;
        }
    };

    return {
        reserveAdId,
        releaseAdId,
    };
}